



































































import {Component, Vue} from '@/shared/component';
import {Emit, Prop} from "vue-property-decorator";
import {Stored} from "vue-stored-prop-decorator";
import {Media, Token} from "@/models";
import {DocumentAchat} from "@/models/DocumentAchat";

import storeToken from "@/stores/modules/token";
import storeDocumentAchat from "@/stores/modules/documentAchat";

@Component()
export default class CrudDocumentAchatShow extends Vue {
	@Prop({ type: DocumentAchat, required: true }) private document!: DocumentAchat;
	
	@Stored(() => storeToken) private token!: Token;
	private confirm: boolean = false;

	private get media(): Media {
		return this.document.media;
	}

	private get href(): string {
		return this.media.hrefs['original']+'?token='+this.token.id;
	}

	private get img(): string {
		if (this.media.type.indexOf('image/') === 0) {
			return 'image';
		}
		if (this.media.type.indexOf('video/') === 0) {
			return 'video';
		}
		
		switch (this.media.type) {
			case 'application/pdf':
			case 'application/xpdf': 
				return 'pdf';
			case 'text/csv':
			case 'application/vnd.ms-excel':
			case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
			case 'application/vnd.oasis.opendocument.spreadsheet':
				return 'calc';
			case 'application/msword':
			case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 
			case 'application/vnd.oasis.opendocument.text': 
				return 'doc';
		}
		
		return 'file';
	}
	
	@Emit()
	private onDelete(): void {
		this.confirm = false;
		storeDocumentAchat.dispatch('delete', this.document);
	}
}
